import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import '../../../Assets/Css/ViewEmployee.scss';
import { customStyle } from '../../../Components/Style';
import Select from "react-select";
import Table from '../../../Components/Table';
import qs from "query-string";
import CustomCalendar from '../../../Components/CustomCalendar';
import { connect } from 'react-redux';
import { getLeaves, updateLeave } from '../../../Services/Leave/action';
import moment from 'moment';
import { Spinner } from 'react-bootstrap';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../../Lib/RoleWiseFeatureWrapper';
import ModulesList from '../../../Assets/ModulesLiist';
import FeaturesList from '../../../Assets/FeaturesList';
import { deleteRecord } from '../../../Services/Delete/action';

const calculateRemainingDaysInCycle = (unpaidLeavesTaken = 0) => {

    const currentDate = moment();
    const currentYear = currentDate.year();
    
    let cycleStartDate, cycleEndDate;
    
    if (currentDate.isBefore(moment(`${currentYear}-07-01`))) {
        cycleStartDate = moment(`${currentYear - 1}-07-01`);
        cycleEndDate = moment(`${currentYear}-07-01`);
    } else {
        cycleStartDate = moment(`${currentYear}-07-01`);
        cycleEndDate = moment(`${currentYear + 1}-07-01`);
    }
    
    const remainingDaysInCalendar = cycleEndDate.diff(currentDate, 'days');
    const availableUnpaidDays = Math.max(0, remainingDaysInCalendar - unpaidLeavesTaken);
    
    return {
        remainingDays: availableUnpaidDays, 
        totalRemainingCalendarDays: remainingDaysInCalendar,
        unpaidLeavesTaken: unpaidLeavesTaken,
        cycleStartDate: cycleStartDate.format('DD-MM-YYYY'),
        cycleEndDate: cycleEndDate.format('DD-MM-YYYY'),
        totalCycleDays: cycleEndDate.diff(cycleStartDate, 'days')
    };
};


const Leave = (props) => {
    const location = useLocation();
    const [openModal, setOpenModal] = useState(false);
    const modalRef = useRef(null);
    const [checked, setChecked] = useState(false);
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportrLoading] = useState(false);
    const [params, setParams] = useState({});
    const [selectedId, setSelectedId] = useState([]);
    const [inData, setInData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const { employeeId } = useParams();
    const [totalEarned, setTotalEarned] = useState(0);
    const [totalUnpaid, setTotalUnpaid] = useState(0);
    const [totalCasualLeavesAvailable, setTotalCasualLeavesAvailable] = useState(0);
   const [totalTakenLeaves, setTotalTakenLeaves] = useState(0);
const [leaveCycleInfo, setLeaveCycleInfo] = useState({
    remainingDays: 0,
    totalRemainingCalendarDays: 0,
    unpaidLeavesTaken: 0,
    cycleStartDate: '',
    cycleEndDate: '',
    totalCycleDays: 0
});
    const currentUser = props?.users?.find(
        (user) => user?.id === props?.user?.id
    );
    const navigate = useNavigate();

    const canView = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Leaves,
        Featur_Name: FeaturesList.View,
    });

    const canDelete = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Leaves,
        Featur_Name: FeaturesList.Delete,
    });
    const canEdit = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Leaves,
        Featur_Name: FeaturesList.Update,
    });

    const canApprove = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Leaves,
        Featur_Name: FeaturesList.Approve,
    });

    const canReject = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Leaves,
        Featur_Name: FeaturesList.Reject,
    });
    const ProjectStatus = [
        { value: "Pending", label: "Pending", color: '#f6b000' },
        { value: "Approved", label: "Approved", color: '#00c292' },
        { value: "Rejected", label: "Rejected", color: '#D21010' },
    ];

    const header = [
        // { field: "checkbox" },
        { field: "Employee" },
        // { field: "Leave Date" },
        { field: "Start Date" },
        { field: "End Date" },
        { field: "Duration" },
        { field: "Leave Status" },
        { field: "Leave Type" },
        { field: "Action" },
    ];
    let footer = true;
    let count = inData.length;

    useEffect(() => {
        fetchData();
    }, [location.search]);

    const fetchData = async () => {
        try {
            setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
            await props?.getLeaves();
        } catch (error) {
            console.error("Error fetching leaves:", error);
        }
    };

    const handleChange = (event) => {
        const { type, checked, id, ids } = event;

        if (type === "select-all") {
            setTotalSelectedIds(checked ? [...ids] : []);
        } else if (type === "select-one") {
            if (checked) {
                setTotalSelectedIds(prev => [...prev, id]);
            } else {
                setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
            }
        }
    };

    const handleClick = async (totalSelectedIds, type) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));

        try {
            if (type === "delete") {
                setDeleteLoading(true);
                await props.deleteInvoices(ids);
                setChecked(false);
                setTotalSelectedIds([]);
            } else if (type === "export") {
                setExportrLoading(true);
                await handlePdfDownload(ids);
                toast.success("Exported Successfully");
            }
        } catch (error) {
            console.error(error);
        } finally {
            await fetchData();
            setDeleteLoading(false);
        }
    };

    const handleAddLeave = () => {
        navigate(`/employees/view/${employeeId}/leave/add`)
    };

    useEffect(() => {
        let casual = 0;
        let earned = 0;
        let unpaid = 0;
        let totalCasualTakenFromBackend = 0;
        const userCasualTotals = {};
        const filtered = props?.leave?.filter(l => l?.employee_id == employeeId);
        const groupedDatesMap = {};

        filtered.forEach(item => {
            const createdAt = item?.createdAt;
const userId = item?.employee_id;
        if (!userCasualTotals[userId] && item?.totalCasualTaken) {
            userCasualTotals[userId] = item.totalCasualTaken;
        }
            if (!groupedDatesMap[createdAt]) {
                groupedDatesMap[createdAt] = [];
            }

            groupedDatesMap[createdAt].push(item);

            if (item?.casual > 0) casual += parseFloat(item?.casual, 10);
            if (item?.unpaid) unpaid += parseFloat(item?.unpaid, 10);
            if (item?.totalCasualTaken) {
                totalCasualTakenFromBackend = item.totalCasualTaken;
            }
            setTotalCasualLeavesAvailable(item?.user?.casual_leave);
        });

        const mapped = [];

        Object.values(groupedDatesMap).forEach(group => {
            if (group.length > 1) {
                const firstItem = group[0];

                mapped.push({
                    checkbox: {
                        value: group.map(i => i?.id),
                        type: "checkbox",
                    },
                    Employee: {
                        value: firstItem?.user?.name,
                        value2: firstItem?.user?.designation?.name,
                        src: firstItem?.user?.profile_pic?.data || "",
                        type: "client"
                    },
                    "Start Date": {
                        value: moment(firstItem?.start_date?.split(" ")?.[0])?.format("DD-MM-YYYY"),
                        type: "date"
                    },
                    "End Date": {
                        value: moment(group[group?.length - 1]?.end_date?.split(" ")?.[0])?.format("DD-MM-YYYY"),
                        type: "date"
                    },
                    Duration: {
                        value: "Multiple",
                        type: "text"
                    },
                    "Leave Status": {
                        value: firstItem?.status,
                        type: "leaveStatus"
                    },
                    "Leave Type": {
                        value: group.every(t => t?.casual > 0) ? "Casual" :
                            group.every(t => t?.unpaid > 0) ? "Unpaid" :
                                "Casual/Unpaid",
                        value2: "",
                        type: "leaveType"
                    },
                    Action: {
                        value2: `/employees/view/${employeeId}/leave/view/multiple`,
                        value3: group.map(i => i?.id),
                        showIsDelete: canDelete && firstItem?.status == "Pending",
                        showIsApprove: canApprove && firstItem?.status != "Approved",
                        showIsReject: canReject && firstItem?.status != "Rejected",
                        value4: "Approve",
                        value5: "Reject",
                        type: "action",
                    },
                    allData: {
                        ...group,
                    }
                });
            } else {
                const item = group[0];

                mapped.push({
                    checkbox: {
                        value: item?.id,
                        type: "checkbox",
                    },
                    Employee: {
                        value: item?.user?.name,
                        value2: item?.user?.designation?.name,
                        src: item?.user?.profile_pic?.data || "",
                        type: "client"
                    },
                    "Start Date": {
                        value: moment(item?.start_date?.split(" ")?.[0])?.format("DD-MM-YYYY"),
                        type: "date"
                    },
                    "End Date": {
                        value: moment(item?.end_date?.split(" ")?.[0])?.format("DD-MM-YYYY"),
                        type: "date"
                    },
                    Duration: {
                        value: (item?.firstHalf && item?.secondHalf) ? 'Single' : "Half Day",
                        type: "text"
                    },
                    "Leave Status": {
                        value: item?.status,
                        type: "leaveStatus"
                    },
                    "Leave Type": {
                        value: (item?.casual > 0 && item?.unpaid > 0) ? "Casual/Unpaid" : item?.unpaid > 0 ? "Unpaid" : "Casual",
                        value2: (item?.firstHalf && item?.secondHalf) ? "" : item?.firstHalf ? 'First Half' : 'Second Half',
                        type: "leaveType"
                    },
                    Action: {
                        value: `/employees/view/${employeeId}/leave/edit`,
                        value2: `/employees/view/${employeeId}/leave/view`,
                        value3: item?.id,
                        showIsEdit: canEdit && item?.status == "Pending",
                        showIsDelete: canDelete && item?.status == "Pending",
                        showIsApprove: canApprove && item?.status != "Approved",
                        showIsCancel: canReject && item?.status != "Rejected",
                        value4: "Approve",
                        value5: "Reject",
                        type: "action",
                    },
                    allData: {
                        ...item
                    }
                });
            }
        });

        setTotalEarned(earned);
        setTotalUnpaid(unpaid);
        setInData(mapped);
    }, [props?.leave]);



    const handleClose = () => {
        setOpenModal(false);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                handleClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClose]);

    useEffect(() => {
        if (totalSelectedIds.length > 0) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    }, [totalSelectedIds]);

    const initialState = {
        projectstatus: { value: "Pending", label: "Pending", color: '#f6b000' }
    }

    const [clientData, setClientData] = useState(initialState);
    const [dateStatus, setDateStatus] = useState(false);
    const [filteredStartDate, setFilteredStartDate] = useState(null);
    const [filteredEndDate, setFilteredEndDate] = useState(null);

    const applyFilters = ({ status, startDate, endDate }) => {
        const filterStartDate = startDate || filteredStartDate;
        const filterEndDate = endDate || filteredEndDate;

        const filtered = inData?.filter((leave) => {
            let matchesStatus = true;
            let matchesDate = true;

            if (filterStartDate && filterEndDate) {
                const filterStart = moment(filterStartDate).startOf('day');
                const filterEnd = moment(filterEndDate).endOf('day');

                const leaveStartDate = moment(leave?.["Start Date"]?.value, "DD-MM-YYYY").startOf('day');
                const leaveEndDate = moment(leave?.["End Date"]?.value, "DD-MM-YYYY").startOf('day');

              matchesDate = leaveStartDate.isSameOrBefore(filterEnd) &&
                leaveEndDate.isSameOrAfter(filterStart);
            }
            if (status) {
                matchesStatus = leave?.["Leave Status"]?.value?.toLowerCase() == status?.value?.toLowerCase();
            }
            return matchesStatus && matchesDate;
        });
        setFilteredData(filtered);
        if (filterStartDate && filterEndDate) {
            setDateStatus(true);
            setFilteredStartDate(filterStartDate);
            setFilteredEndDate(filterEndDate);
        }
    };

    const handleClear = () => {
        setClientData({
            projectstatus: "",
        });
        setDateStatus(false);
        setFilteredData([]);
        setFilteredStartDate(null);
        setFilteredEndDate(null);
    }

    useEffect(() => {
        if (inData?.length > 0 && initialState.projectstatus) {
            applyFilters({ status: initialState.projectstatus });
        }
    }, [inData]);

useEffect(() => {
    if (props?.user?.id) {
        const currentUserUnpaidTaken = parseFloat(props?.user?.unpaid_leave || 0);
        const cycleInfo = calculateRemainingDaysInCycle(currentUserUnpaidTaken);
        setLeaveCycleInfo(cycleInfo);
    }
}, [props?.leave, props?.user?.unpaid_leave]);
useEffect(() => {
    let totalCasualTakenFromBackend = 0;
    const employeeLeaves = props?.leave?.filter(l => l?.employee_id == employeeId);
    const firstLeaveRecord = employeeLeaves?.[0];
    if (firstLeaveRecord && firstLeaveRecord?.totalCasualTaken !== undefined) {
        totalCasualTakenFromBackend = parseFloat(firstLeaveRecord.totalCasualTaken) || 0;
    }
    setTotalTakenLeaves(totalCasualTakenFromBackend);
    
}, [props?.leave, employeeId]);

    return (
        <div className='viewEmployee-main'>
            <div className='row'>
                <div className='profile-container'>
                    <div className='row'>
                        <div class="leave-part common-card">
                            <div className='profile-heading'>
                                <span>Leave Quota</span>
                            </div>
                            <div class="leave-bar">
                                <div class="casual">
                                    <div className='title'>Casual</div>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        flexDirection: 'row'
                                    }}>
                                        <div>
                                            <p>No. of</p>
                                            <p>Leaves</p>
                                            <span>{parseFloat(props?.user?.casual_leave || 0).toFixed(1)}</span>
                                        </div>
                                        <div>
                                            <p>Total Leaves</p>
                                            <p>Taken</p>
                                            <span>{totalTakenLeaves.toFixed(1) || 0.00}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="unpaid">
                                    <div className='title'>Unpaid Leave</div>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        flexDirection: 'row'
                                    }}>
                                        <div>
                                            <p>No. of</p>
                                            <p>Leaves</p>
                                            <span>{leaveCycleInfo?.remainingDays || 0}</span>
                                        </div>
                                        <div>
                                            <p>Total Leaves</p>
                                            <p>Taken</p>
                                            <span>{parseFloat(props?.user?.unpaid_leave || 0).toFixed(1)}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className='col-lg-6 col-md-6 col-sm-12 '>
                    <RoleWiseFeatureWrapper
                        modules={props?.modules}
                        features={props?.features}
                        user={props?.user}
                        ModuleName={ModulesList.Leaves}
                        Featur_Name={FeaturesList.Create}>

                        <button
                            className="export-btn me-2"
                            id="exportBtn"
                            // disabled={!checked || exportLoading}
                            onClick={handleAddLeave}
                        >
                            {/* {exportLoading ? (
                            <Spinner
                            as="span"
                            animation="border"
                            className="custom-spinner"
                            role="status"
                            aria-hidden="true"
                            />
                            ) : (
                                "Export"
                                )} */}
                            Add Leave
                        </button>
                    </RoleWiseFeatureWrapper>

                    {/* <button
                        className="export-btn"
                        id="exportBtn"
                        disabled={!checked || exportLoading}
                        onClick={(e) => {
                            e.preventDefault();
                            handleClick(totalSelectedIds, "export");
                        }}
                    >
                        {exportLoading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                className="custom-spinner"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            "Export"
                        )}
                    </button> */}

                    {(clientData?.projectstatus || filteredData?.length > 0 || dateStatus) && (
                        <button
                            className="export-btn"
                            disabled={props.loading}
                            onClick={handleClear}
                        >
                            {props.loading ? (
                                <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                            ) : (
                                'Clear'
                            )}
                        </button>
                    )}
                </div>

                <div className="col-lg-3 col-md-3 col-sm-12">
                    <div className="card-type">
                        <CustomCalendar
                            inData={inData}
                            setFilteredData={setFilteredData}
                            selectedStatus={clientData?.projectstatus}
                            applyFilters={(params) => { applyFilters(params) }}
                            startDate={filteredStartDate}
                            endDate={filteredEndDate}
                            setStartDate={setFilteredStartDate}
                            setEndDate={setFilteredEndDate} />
                    </div>
                </div>

                <div className="col-lg-3 col-md-3 col-sm-12">
                    <label className="labeling">
                        <Select
                            options={ProjectStatus}
                            styles={{
                                ...customStyle,
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 2,
                                    width: '100%',
                                }),
                                control: (provided) => ({
                                    ...provided,
                                    boxShadow: 'none',
                                    border: '1px solid #ced4da',
                                }),
                                placeholder: (provided) => ({
                                    ...provided,
                                    color: '#6c757d',
                                }),
                            }}
                            value={clientData.projectstatus}
                            placeholder="Status"
                            onChange={(val) => {
                                setClientData((preVal) => ({
                                    ...preVal,
                                    projectstatus: val
                                }));

                                applyFilters({ status: val, startDate: filteredStartDate, endDate: filteredEndDate })
                            }}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: "#5757fe",
                                    primary: "#5757fe",
                                },
                            })}
                            isSearchable
                            getOptionLabel={(e) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span
                                        style={{
                                            height: '12px',
                                            width: '12px',
                                            backgroundColor: e.color,
                                            borderRadius: '50%',
                                            display: 'inline-block',
                                            marginRight: '10px',
                                            marginLeft: '10px'
                                        }}
                                    />
                                    {e.label}
                                </div>
                            )}
                            getOptionValue={(e) => e.value}
                        />
                    </label>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="invoice-table-part">
                        <Table
                            header={header}
                            data={(clientData?.projectstatus || dateStatus) ? filteredData : inData}
                            footer={footer}
                            count={count}
                            checked={checked}
                            records={count}
                            totalSelectedIds={totalSelectedIds}
                            defaultParams={params}
                            selectedId={selectedId}
                            handleChange={handleChange}
                            loading={props.loading}
                            showIsView={canView}
                            updateLeave={props?.updateLeave}
                            deleteRecord={props?.deleteRecord}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        loading: state?.leaveReducer?.loading,
        leave: state?.leaveReducer?.leave,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user,
        users: state.userReducer.users,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getLeaves: () => {
            dispatch(getLeaves())
        },
        updateLeave: (id, data) => {
            dispatch(updateLeave(id, data))
        },
        deleteRecord: async (id, inputValue) => {
            await dispatch(deleteRecord(id, inputValue))
            await dispatch(getLeaves())
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Leave)